define('components/photoset/item/viewmodel',
    [
        'viewmodels/base_es5',
        'components/photoset/helpers',
        'components/photoset/item/states'        
    ],

    function (Base, helpers, states) {
        const { NodeTracker: Tracker } = require('managers/nodes/tracker');

        function ViewModel(config) {
            Base.call(this, config);

            this.contentNode = ko.observable(null);
            this.contentTracker = this._register(new Tracker({ node: this.contentNode }));
            this.fancyboxNode = ko.observable(null).extend({ notifyIfChanged: true });
            this.hasFancybox = ko.pureComputed(function () { return this.fancyboxNode() != null }, this);

            this.top = this.model.top;
            this.left = this.model.left;
            this.width = this.model.width;
            this.height = this.model.relHeight.mapNotNull(function (value) { return value * 100 }).extend({ deferred: true });

            this.showCounter = this.model.showCounter;

            this.isReady = ko.pureComputed(function () { return this.top() != null && this.left() != null }, this).extend({ deferred: true });
            this.isVisible = ko.pureComputed(function () { return this.isReady() && this.model.isVisible() }, this).extend({ deferred: true });
        }

        ViewModel.prototype = Object.create(Base.prototype);
        ViewModel.prototype.constructor = ViewModel;

        ViewModel.prototype.onCoverClick = function () {
            if (this.showCounter())
                $(this.fancyboxNode()).trigger('wcc-fancybox.click');
        };

        ViewModel.prototype.beforeInit = function () {
            Base.prototype.beforeInit.call(this);

            this.disposables.register([
                ko.computed(this._findFancybox, this)
            ]);

            ko.applyBindingsToNode(this.element, {
                'visible': this.isVisible,

                'css': {
                    'photoset-new__item': true
                },
                'style': {
                    'left': this.left.mapNotNull(helpers.toStyleValue),
                    'width': this.width.mapNotNull(helpers.toStyleValue),
                    'margin-top': this.top.mapNotNull(helpers.toStyleValue)
                },
                'attr': {
                    'data-row': this.model.rowIdx,
                    'data-col': this.model.colIdx
                }
            });
        };

        ViewModel.prototype.init = function () {
            requestAnimationFrame(function () {
                this.model.state(states.active);
            }.bind(this));
        };

        ViewModel.prototype._findFancybox = function () {
            if (this.showCounter() && !this.hasFancybox()) {
                ko.ignoreDependencies(function (contentNode) {
                    var node = $(contentNode).find('.wcc-fancybox')[0];

                    if (node != null)
                        this.fancyboxNode(node);
                }, this, [this.contentNode(), this.contentTracker.mutations()]);
            }
        };

        return ViewModel;
    });